import { Confidence } from '@spotify-confidence/sdk';
import {
  Impression,
  Interaction,
  PageImpressionEvent,
  TourInteraction,
  TrackingApi,
  elementPathToString,
  notifyImpression,
  notifyInteraction,
  notifyPageImpression,
} from '@spotify/plugin-confidence-tracking-react';

const INTERACTION_EVENT_ID = 'ui-interaction';
const IMPRESSION_EVENT_ID = 'ui-impression';
const PAGE_IMPRESSION_EVENT_ID = 'ui-page-impression';
const TOUR_INTERACTION_EVENT_ID = 'ui-interaction-onboarding-tour';

export class TrackingConfidenceEvents implements TrackingApi {
  private confidenceApi: Confidence;

  constructor(confidenceApi: Confidence) {
    this.confidenceApi = confidenceApi;
  }

  trackInteraction(interaction: Interaction) {
    const { elementPath, action, type, data } = interaction;
    this.confidenceApi.track(INTERACTION_EVENT_ID, {
      path: elementPathToString(elementPath),
      action,
      type,
      data,
    });
    notifyInteraction(interaction);
  }

  trackImpression(impression: Impression) {
    const { elementPath, data } = impression;
    this.confidenceApi.track(IMPRESSION_EVENT_ID, {
      path: elementPathToString(elementPath),
      data,
    });
    notifyImpression(impression);
  }

  trackPageImpression(event: PageImpressionEvent) {
    const { pageId, pageViewId, fromPageId, fromPageViewId, data } = event;
    this.confidenceApi.track(PAGE_IMPRESSION_EVENT_ID, {
      pageId,
      pageViewId,
      fromPageId: fromPageId ?? '',
      fromPageViewId: fromPageViewId ?? '',
      data,
    });
    notifyPageImpression(event);
  }

  trackTourInteraction(interaction: TourInteraction) {
    const { action, tourId, totalSteps, stepIndex } = interaction;
    this.confidenceApi.track(TOUR_INTERACTION_EVENT_ID, {
      action,
      tourId,
      totalSteps,
      ...(stepIndex !== undefined ? { stepIndex } : {}),
    });
  }
}
